//  React TS Helper Functions
import pxToRem from '../../functions/pxToRem'

// types
type Types = any

const dialogActions: Types = {
  styleOverrides: {
    root: {
      padding: pxToRem(16),
    },
  },
}

export default dialogActions
